import createIcon from '../../createIcon';

/**
 * @component @name Bento
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTFWNUgyMEMyMS4xIDUgMjIgNS45IDIyIDdWMTFIMTZaTTIwIDE5QzIxLjEgMTkgMjIgMTguMSAyMiAxN1YxM0gxNlYxOUgyMFpNMTQgNVYxOUg0QzIuOSAxOSAyIDE4LjEgMiAxN1Y3QzIgNS45IDIuOSA1IDQgNUgxNFpNOS41IDEyQzkuNSAxMS4xNyA4LjgzIDEwLjUgOCAxMC41QzcuMTcgMTAuNSA2LjUgMTEuMTcgNi41IDEyQzYuNSAxMi44MyA3LjE3IDEzLjUgOCAxMy41QzguODMgMTMuNSA5LjUgMTIuODMgOS41IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bento = createIcon('Bento', [
  [
    'path',
    {
      d: 'M16 11V5H20C21.1 5 22 5.9 22 7V11H16ZM20 19C21.1 19 22 18.1 22 17V13H16V19H20ZM14 5V19H4C2.9 19 2 18.1 2 17V7C2 5.9 2.9 5 4 5H14ZM9.5 12C9.5 11.17 8.83 10.5 8 10.5C7.17 10.5 6.5 11.17 6.5 12C6.5 12.83 7.17 13.5 8 13.5C8.83 13.5 9.5 12.83 9.5 12Z',
      key: 'x6u8td',
    },
  ],
]);

export default Bento;
